import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { QuestionFormLog } from "./QuestionFormTypes";

export interface CvpGetQuestionFormLogAnonymousResponse
  extends BackendResponse {
  item: QuestionFormLog;
}

export interface CvpGetQuestionFormLogAnonymousParameters
  extends NextApiParams {
  token: string;
}

export const getQuestionFormLogAnonymous = withNextApi<
  CvpGetQuestionFormLogAnonymousResponse,
  CvpGetQuestionFormLogAnonymousParameters
>("/cvp/CvpGetQuestionFormLogAnonymous", { method: "GET" });
